"use client";
import React, { Suspense } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

function LoginInner() {
	const router = useRouter();
	const sp = useSearchParams();
	const next = sp.get("next") || "/admin";
	const [email, setEmail] = React.useState("");
	const [password, setPassword] = React.useState("");
	const [loading, setLoading] = React.useState(false);
	const [error, setError] = React.useState<string | null>(null);

	const onSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		setLoading(true);
		setError(null);
		try {
			const res = await fetch("/api/auth/login", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ email, password }),
			});
			const data = await res.json();
			if (!res.ok) throw new Error(data?.error || "Login failed");
			router.push(next);
		} catch (err) {
			const msg = err instanceof Error ? err.message : "Login failed";
			setError(msg);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="max-w-md mx-auto">
			<h1 className="text-2xl font-semibold mb-4">Admin Login</h1>
			<form onSubmit={onSubmit} className="space-y-4 card p-6">
				<Input
					label="Email"
					type="email"
					value={email}
					onChange={(e) => setEmail(e.target.value)}
					required
				/>
				<Input
					label="Password"
					type="password"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					required
				/>
				{error ? (
					<p className="help" style={{ color: "var(--danger)" }}>
						{error}
					</p>
				) : null}
				<Button variant="primary" disabled={loading}>
					{loading ? "Signing in..." : "Sign in"}
				</Button>
			</form>
		</div>
	);
}

export default function LoginPage() {
	return (
		<Suspense
			fallback={<div className="max-w-md mx-auto card p-6">Loading…</div>}
		>
			<LoginInner />
		</Suspense>
	);
}
